import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InquiriesRoutePath } from '../../core/enums/route-types.enum';
import { NotificationInterface } from '../../core/models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class PriceRequestNotificationOpenerService {
  private router = inject(Router);

  open(notification: NotificationInterface) {
    const path = ['/', InquiriesRoutePath.ROOT, InquiriesRoutePath.CUSTOM_MADE_PRICE_REQUESTS, notification.objectId];
    const isStatusChange = notification.details?.status;
    this.router.navigate(isStatusChange ? path : [...path, 'communication']);
  }
}
